export default __webpack_public_path__ + "static/media/path9.ad190b5c.svg";